<template>
  <v-container
    class="px-1 py-1"
    fluid
    grid-list-sm>
    <v-toolbar
      color="primary">
      <v-toolbar-title
        class="headline white--text">
        {{ $t(translation + ".header") + (this.headerAdditionalText ? " " + this.headerAdditionalText : "") }}
      </v-toolbar-title>

      <v-tooltip top>
        <template
          v-slot:activator="{ on, attrs }">
          <v-btn
            class="ml-4 info"
            dark
            v-bind="attrs"
            v-on="on"
            :disabled="tableDataLoading || tableData.length === 0"
            :loading="reportDownloading"
            @click="refreshData(false, false, reportData)">
            <v-icon class="white--text">mdi-download</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('tooltips.report') }}</span>
      </v-tooltip>

      <v-spacer></v-spacer>
      <v-btn
        v-if="!isAdmin && (!cb_help_status_id || cb_help_status_id === 3) "
        class="mr-4 info"
        dark
        @click="addEditItemDialog=true">
        {{ $t(translation + '.add') }}
      </v-btn>
      <v-tooltip top>
        <template
          v-slot:activator="{ on, attrs }">
          <v-btn
            dark
            :loading="tableDataLoading"
            :disabled="tableDataLoading"
            v-bind="attrs"
            v-on="on"
            class="warning"
            @click="refreshData(true, true)">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('tooltips.refresh') }}</span>
      </v-tooltip>

    </v-toolbar>
    <v-spacer></v-spacer>
    <v-data-table
      dark
      :mobile-breakpoint="breakpoint"
      :page="page"
      :pageCount="numberOfPages"
      :headers="headers"
      :items="tableData"
      :options.sync="options"
      :server-items-length="totalRows"
      :footer-props="{
        itemsPerPageOptions: itemsPerPageOptions,
        'items-per-page-text': '',
        'page-text': fromItem + '-' + toItem + ' ' + $t('general.of') + ' ' + totalRows
      }"
      :dense="true"
      :loading-text="$t('loading_data')"
      class="elevation-1 secondary white--text"
      sort-by="name"
      :loading="tableDataLoading"
      height="80vh"
    >
      <template v-slot:item.total="{ item }">
        <div class="text-right">
          {{ formatCurrency(item.total) }}
        </div>
      </template>
      <template v-slot:item.date_from="{ item }">
        {{ formatDate(item.date_from) }}
      </template>
      <template v-slot:item.date_to="{ item }">
        {{ formatDate(item.date_to) }}
      </template>
      <!--      <template v-slot:item.is_active="{ item }">-->
      <!--        <v-chip small-->
      <!--                :class="{'error inactive-row white&#45;&#45;text':(!item.is_active) , 'secondary white&#45;&#45;text':(item.is_active)}">-->
      <!--          {{ item.is_active ? $t('active') : $t('not_active') }}-->
      <!--        </v-chip>-->
      <!--      </template>-->
      <!-------------------------------------  DETAILS EDIT DELETE  ----------------------------------------------->
      <template v-slot:item.actions="{ item }">
        <v-layout align-center justify-center>
          <div v-if="!isAdmin">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="openEditDialog(item)">
                  <v-icon class="info--text">mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('tooltips.edit') }}</span>
            </v-tooltip>
          </div>

          <v-tooltip
            v-if="isAdmin && cb_help_status_id === 3"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click.stop="openViewDialog(item)">
                <v-icon class="info--text">mdi-eye-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('tooltips.view') }}</span>
          </v-tooltip>

          <v-tooltip
            v-if="[2].includes(cb_help_status_id)"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                :loading="sendLoadingId === item.id"
                v-bind="attrs"
                v-on="on"
                @click.stop="send(item)">
                <v-icon class="warning--text">mdi-send</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('tooltips.send') }}</span>
          </v-tooltip>


          <!--Admin-->
          <div v-if="isAdmin">
            <div v-if="cb_help_status_id === 3">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    dark
                    :loading="acceptLoadingId === item.id"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="accept(item)">
                    <v-icon class="success--text">mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('tooltips.accept') }}</span>
              </v-tooltip>

              <v-tooltip
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    dark
                    :loading="rejectLoadingId === item.id"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="openRejectDialog(item)">
                    <v-icon class="error--text">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('tooltips.reject') }}</span>
              </v-tooltip>
            </div>
          </div>

          <v-tooltip
            v-if="isAdmin && [1,2].includes(cb_help_status_id)"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                dark
                :loading="deleteLoadingId === item.id"
                @click="onDelete(apiDelete,item, false)">
                <v-icon class="error--text">{{ item.is_active ? 'mdi-trash-can-outline' : 'mdi-autorenew' }}</v-icon>
              </v-btn>
            </template>
            <span>{{
                showInactive ? (item.is_active ? $t('tooltips.deactivate') : $t('tooltips.activate')) : $t('tooltips.delete')
              }}</span>
          </v-tooltip>

        </v-layout>
      </template>
      <!----------------------------------- ## FILTERS ## ------------------------------------>
      <template v-slot:body.prepend>
        <tr style="height: 60px !important;">
          <th
            v-for="header in headers"
            :key="header.name"
            class="py-0 px-2 my-0 secondary white--text">
            <v-select
              v-if="header.name === 'active'"
              class="justify-center pt-2 mt-0"
              dark
              dense
              hide-details
              v-model="filters[header.value]"
              @change="refreshData"
              :items="activeObjects"
              item-value="value"
              item-text="text"
              style="font-size: inherit; text-align: right !important;">
            </v-select>
            <v-text-field
              v-else-if="header.name !== 'actions'"
              v-model="filters[header.value]"
              @keyup.enter.native="refreshData"
              :placeholder="'Filter ' + header.text"
              filled
              dense
              height="10px"
              hide-details
              style="font-size: inherit;"
              class="secondary ma-0 pa-0"
              v-eager
              enterkeyhint="done"
            ></v-text-field>
            <v-layout
              v-else class="justify-center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    depressed
                    small
                    v-bind="attrs"
                    v-on="on"
                    :disabled="tableDataLoading"
                    color="info"
                    @click="refreshData">
                    <v-icon>mdi-search-web</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('tooltips.search') }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    depressed
                    class="ml-1"
                    small
                    v-bind="attrs"
                    v-on="on"
                    :disabled="tableDataLoading"
                    color="error"
                    @click="refreshData(true, true)">
                    <v-icon>mdi-close-circle</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('tooltips.cancel_search') }}</span>
              </v-tooltip>
            </v-layout>
          </th>
        </tr>
      </template>
      <!----------------------------------- ## TOTALS ## ------------------------------------>
      <template v-slot:body.append>
        <tr v-if="tableData && tableData.length > 0">
          <th
            v-for="header in headers"
            :key="header.name"
            class="py-0 pr-1 my-0 white--text tertiary text-right">
            {{ header.name === 'total' ? sumTotal : (header.name === 'help_type' ? $t('general.total') : '') }}
          </th>
        </tr>
      </template>
      <!-------------------------------- ## NO DATA ## ----------------------------------->
      <template v-slot:no-data>
        <div class="text-xs-center">
          <v-alert color="error" icon="mdi-alert-circle-outline">
            {{ errorMessage }}
          </v-alert>
        </div>
      </template>
    </v-data-table>
    <!---------------------------------- Add item Dialog  ----------------------------------------->
    <add-edit-item
      :addItemDialog="addEditItemDialog"
      :dataForModal="dataForModal"
      :read-only="isAdmin && cb_help_status_id === 3"
      @close="closeAddEditDialog"
      @addEmit="addEmit"
      @editEmit="editEmit"
    />
    <!---------------------------------- Reject item Dialog  ----------------------------------------->
    <reject-item
      :reject-item-dialog="rejectItemDialog"
      :data-for-modal="dataForModal"
      @close="closeRejectDialog"
      @onReject="onReject"
      @closeReject="closeRejectDialog"
    />
    <!---------------------------------- Snackbar  ----------------------------------------->
    <v-snackbar
      v-model="snackbar.show"
      :bottom=true
      :color="snackbar.color"
      :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn dark text @click="snackbar.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import {
  findById,
  addEmit,
  editEmit,
  onDelete,
  refresh,
  search,
  formatCurrency,
  formatDate,
  readTableDataPostPagination,
  downloadReport
} from "../../../statics/DataTableFunctions";
import AddEditHelpRegistriesCovid from "../../../components/helpRegistries/covid/AddEditHelpRegistriesCovid";
import axios from "axios";
import RejectHelpRegistry from "../../../components/helpRegistries/RejectHelpRegistry";


export default {
  name: "HelpRegistriesCovid",
  components: {
    'add-edit-item': AddEditHelpRegistriesCovid,
    'reject-item': RejectHelpRegistry,
  },
  props: {
    headerAdditionalText: {
      default: "",
      type: String
    },
    apiRead: {
      default: '/api/help_registries/covid/index_pagination',
      type: String
    },
    cb_help_status_id: {
      default: null,
      type: Number
    },
  },
  data() {
    return {
      isAdmin: false,
      userRoles: JSON.parse(localStorage.getItem('roles')) ? JSON.parse(localStorage.getItem('roles')).map(role => role.id) : [],
      breakpoint: 0,
      page: 1,
      numberOfPages: 10,
      totalRows: 0,
      itemsPerPageOptions: [
        10,
        20,
        30,
        50,
        100,
        200,
        500,
        1000
      ],
      options: {
        sortBy: [
          'date_from'
        ],
        sortDesc: [
          true
        ]
      },
      translation: 'help_registries.covid',
      apiDelete: '/api/help_registries/covid/destroy',
      apiSend: '/api/help_registries/change_status/send',
      apiAccept: '/api/help_registries/change_status/accept',
      showInactive: false,
      show_columns: [
        "help_registries.id",
        "help_registries.total",
        "help_registries.date_from",
        "help_registries.date_to",
        "help_registries.is_active",
      ],
      show_columns_cb_help_measure_relation: [
        "name"
      ],
      show_columns_cb_agency_decision_relation: [
        "number"
      ],
      show_columns_cb_help_receiver_relation: [
        "name",
        "pin"
      ],
      show_columns_cb_help_user_type_relation: [
        "name"
      ],
      show_columns_cb_activity_relation: [
        "name"
      ],
      show_columns_cb_help_provider_relation: [
        "name"
      ],
      show_columns_cb_help_status_relation: [
        "name"
      ],
      show_columns_cb_provider_decisions_relation: [
        "number"
      ],
      show_columns_cb_help_type_relation: [
        "name"
      ],
      show_columns_cb_help_goal_relation: [
        "name"
      ],
      dataForModal: null,
      addEditItemDialog: false,
      rejectItemDialog: false,
      editItemDialog: false,
      reportData:{
        folder: 'helpRegistries/covid',
        name: 'helpRegistryCovid',
        type: '.pdf'
      },
      reportDownloading: false,
      tableDataLoading: false,
      isRefreshingData: false,
      tableData: [],
      filteredTableData: [],
      filters: {
        is_active: '',
      },
      itemsPerPage: 10,
      deleteLoadingId: -1,
      sendLoadingId: -1,
      acceptLoadingId: -1,
      rejectLoadingId: -1,
      errorMessage: this.$t('no_data'),
      snackbar: {
        color: 'success',
        show: false,
        text: '',
        timeout: 3000,
      },

    }
  },
  methods: {
    search,
    findById,
    refresh,
    onDelete,
    downloadReport,
    readTableDataPostPagination,
    formatCurrency,
    formatDate,
    addEmit,
    editEmit,
    isUserAdmin() {
      return this.userRoles.includes(1);
    },
    openEditDialog(item) {
      this.addEditItemDialog = true;
      this.dataForModal = item;
    },
    openViewDialog(item) {
      this.addEditItemDialog = true;
      this.readOnly = true;
      this.dataForModal = item;
    },
    openRejectDialog(item) {
      this.rejectLoadingId = item.id
      this.rejectItemDialog = true;
      this.dataForModal = item;
    },
    closeAddEditDialog() {
      this.addEditItemDialog = false;
      this.dataForModal = null;
    },
    closeRejectDialog() {
      this.rejectLoadingId = -1
      this.rejectItemDialog = false;
      this.dataForModal = null;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    scrollToBottom() {
      window.scrollTo(0, document.body.scrollHeight);
    },
    refreshData(resetPagination = false, resetFilters = false, reportData = null) {
      if (resetPagination) {
        this.options.page = 1;
        this.options.itemsPerPage = 10;
        this.isRefreshingData = true;
      }
      if (resetFilters) {
        Object.keys(this.filters).forEach(f => {
          this.filters[f] = ''
        });
      }
      this.readTableDataPostPagination(
        this.apiRead,
        true,
        this.show_columns, {
          filters: this.filters,
          options: this.options,
          report_data: reportData,
          cb_help_status_id: this.cb_help_status_id,
          show_columns_cb_help_measure_relation: this.show_columns_cb_help_measure_relation,
          show_columns_cb_agency_decision_relation: this.show_columns_cb_agency_decision_relation,
          show_columns_cb_help_receiver_relation: this.show_columns_cb_help_receiver_relation,
          show_columns_cb_help_user_type_relation: this.show_columns_cb_help_user_type_relation,
          show_columns_cb_activity_relation: this.show_columns_cb_activity_relation,
          show_columns_cb_help_provider_relation: this.show_columns_cb_help_provider_relation,
          show_columns_cb_help_status_relation: this.show_columns_cb_help_status_relation,
          show_columns_cb_provider_decisions_relation: this.show_columns_cb_provider_decisions_relation,
          show_columns_cb_help_type_relation: this.show_columns_cb_help_type_relation,
          show_columns_cb_help_goal_relation: this.show_columns_cb_help_goal_relation
        },
        !!reportData
      )
    },
    send(item) {
      this.sendLoadingId = item.id
      this.$swal
        .fire({
          title: this.$t('help_registries.send'),
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#4caf50",
          cancelButtonColor: "#ff5252",
          reverseButtons: false,
          cancelButtonText: this.$t('deny'),
          confirmButtonText: this.$t('confirm')
        })
        .then(result => {
          if (result.value) {
            axios.put(this.apiSend + '/' + item.id)
              .then(({data}) => {
                this.tableData.splice(this.findById(item.id, this.tableData), 1)
                this.snackbar.color = 'success'
                this.snackbar.text = this.$t('operation_success');
                this.snackbar.show = true;
                this.sendLoadingId = -1;
              })
              .catch(error => {
                this.sendLoadingId = -1
                if (error.response.status === 401) {
                  this.$swal.fire({
                    type: 'info',
                    title: "Info",
                    text: this.$t('validation.session'),
                  })
                  this.$router.push('/login')
                } else {
                  this.$swal.fire({
                    type: 'error',
                    title: this.$t('validation.error'),
                    text: error.response.data.message,
                  })
                }
              });
          } else {
            this.sendLoadingId = -1;
          }
        });
    },
    accept(item) {
      this.acceptLoadingId = item.id
      this.$swal
        .fire({
          title: this.$t('help_registries.accept'),
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#4caf50",
          cancelButtonColor: "#ff5252",
          reverseButtons: false,
          cancelButtonText: this.$t('deny'),
          confirmButtonText: this.$t('confirm')
        })
        .then(result => {
          if (result.value) {
            axios.put(this.apiAccept + '/' + item.id)
              .then(({data}) => {
                this.tableData.splice(this.findById(item.id, this.tableData), 1)
                this.snackbar.color = 'success'
                this.snackbar.text = this.$t('operation_success');
                this.snackbar.show = true;
                this.acceptLoadingId = -1;
              })
              .catch(error => {
                this.acceptLoadingId = -1
                if (error.response.status === 401) {
                  this.$swal.fire({
                    type: 'info',
                    title: "Info",
                    text: this.$t('validation.session'),
                  })
                  this.$router.push('/login')
                } else {
                  this.$swal.fire({
                    type: 'error',
                    title: this.$t('validation.error'),
                    text: error.response.data.message,
                  })
                }
              });
          } else {
            this.acceptLoadingId = -1;
          }
        });
    },
    onReject(item) {
      this.rejectItemDialog = false;

      this.tableData.splice(this.findById(item.id, this.tableData), 1);

      this.snackbar.color = 'success'
      this.snackbar.text = this.$t('operation_success');
      this.snackbar.show = true;

      this.rejectLoadingId = -1;
    }
  },
  computed: {
    fromItem() {
      return this.options.page === 1 ? 1 : (this.options.page - 1) * this.options.itemsPerPage + 1
    },
    toItem() {
      if (this.options.itemsPerPage > this.totalRows) {
        return this.totalRows;
      }
      if (this.options.page === 1) {
        return this.options.itemsPerPage
      }

      const toItems = this.options.page * this.options.itemsPerPage;

      if (toItems > this.totalRows) {
        return this.totalRows;
      }

      return toItems;
    },
    sumTotal() {
      let sum = 0;
      this.tableData.forEach(item => {
        sum += parseFloat(item.total);
      })
      return formatCurrency(sum);
    },
    headers() {
      let headers = [
        {
          text: this.$t(this.translation + '.help_provider'),
          name: 'cb_help_providers.name',
          align: 'left',
          sortable: true,
          value: 'cb_help_providers.name',
          width: '8%'
        },
        {
          text: this.$t(this.translation + '.help_receiver.name'),
          name: 'help_receiver_name',
          align: 'left',
          sortable: true,
          value: 'cb_help_receivers.name',
          width: '15%'
        },
        {
          text: this.$t(this.translation + '.help_receiver.pib'),
          name: 'help_receiver_pib',
          align: 'left',
          sortable: true,
          value: 'cb_help_receivers.pin',
          width: '2%'
        },
        {
          text: this.$t(this.translation + '.help_measure'),
          name: 'help_measure',
          align: 'left',
          sortable: true,
          value: 'cb_help_measures.name',
          width: '15%'
        },
        {
          text: this.$t(this.translation + '.agency_decision'),
          name: 'agency_decision',
          align: 'left',
          sortable: true,
          value: 'cb_agency_decisions.number',
          width: '8%'
        },
        {
          text: this.$t(this.translation + '.provider_decision'),
          name: 'provider_decision',
          align: 'left',
          sortable: true,
          value: 'cb_provider_decisions.number',
          width: '8%'
        },
        {
          text: this.$t(this.translation + '.help_user_type'),
          name: 'help_user_type',
          align: 'left',
          sortable: true,
          value: 'cb_help_user_types.name',
          width: '10%'
        },
        {
          text: this.$t(this.translation + '.activity'),
          name: 'activity',
          align: 'left',
          sortable: true,
          value: 'cb_activities.name',
          width: '12%'
        },
        {
          text: this.$t(this.translation + '.help_type'),
          name: 'help_type',
          align: 'left',
          sortable: true,
          value: 'cb_help_types.name',
          width: '10%'
        },
        {
          text: this.$t(this.translation + '.total'),
          name: 'total',
          align: 'left',
          sortable: true,
          value: 'total',
          width: '6%'
        },
        {
          text: this.$t(this.translation + '.date_from'),
          name: 'date_from',
          align: 'left',
          sortable: true,
          value: 'date_from',
          width: '3%'
        },
        // {
        //   text: this.$t(this.translation + '.status'),
        //   name: 'status',
        //   align: 'left',
        //   sortable: true,
        //   value: 'cb_help_statuses.name'
        // },
        // {
        //   text: this.$t(this.translation + '.comment'),
        //   name: 'comment',
        //   align: 'left',
        //   sortable: true,
        //   value: 'comment'
        // },
        // {
        //   text: this.$t(this.translation + '.active'),
        //   name: 'active',
        //   align: 'left',
        //   sortable: true,
        //   value: 'is_active'
        // },
      ];

      if (this.cb_help_status_id && this.cb_help_status_id === 1) {
        headers.push({
          text: this.$t(this.translation + '.date_to'),
          name: 'date_to',
          align: 'left',
          sortable: true,
          value: 'date_to',
          width: '3%'
        });
      }

      if (!this.cb_help_status_id || this.cb_help_status_id === 2 || this.isAdmin) {
        headers.push({
          text: this.$t('actions'),
          name: 'actions',
          align: 'center',
          sortable: false,
          value: 'actions'
        });
      }
      return headers;
    },
    activeObjects() {
      return [
        {value: "", text: this.$t('all')},
        {value: 'true', text: this.$t('active')},
        {value: 'false', text: this.$t('not_active')},
      ]
    },
  },
  watch: {
    options: {
      handler() {
        if (!this.isRefreshingData) {
          this.refreshData()
        }
      },
      deep: true
    }
  },
  created() {
    this.isAdmin = this.isUserAdmin();
  }
}
</script>

<style>

</style>

